var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 51,
    viewBox: "0 0 117 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_3278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.779 26.9067H103.079V28.6481H104.779V26.9067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6 26.8096H111.711V28.7444H113.6V26.8096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.344 9.43506H103.513V10.2864H104.344V9.43506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.835 17.8708H103.003V19.7477H104.835V17.8708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.369 22.2048H107.234V24.3912H109.369V22.2048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.057 22.7659H99.0365V23.8107H100.057V22.7659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.453 27.3513H116.622V28.2027H117.453V27.3513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6461 8.62231H85.2283V11.0989H87.6461V8.62231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.226 9.16406H98.8661V10.5572H100.226V9.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4994 13.6526H90.1394V15.0457H91.4994V13.6526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1276 17.8513H94.2386V19.7862H96.1276V17.8513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.585 13.3044H98.5454V15.3941H100.585V13.3044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.831 17.5034H98.2617V20.1348H100.831V17.5034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7509 26.1714H93.6152V29.3832H96.7509V26.1714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5987 9.43506H94.7676V10.2864H95.5987V9.43506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2351 4.96533H90.4039V5.81667H91.2351V4.96533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3918 22.0498H93.974V24.5264H96.3918V22.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.831 26.4614H98.2617V29.0928H100.831V26.4614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.476 13.2852H85.3982V15.4135H87.476V13.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0184 13.3816H81.1295V15.3164H83.0184V13.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7637 8.89307H89.8748V10.8279H91.7637V8.89307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.203 13.3044H94.163V15.3941H96.203V13.3044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9859 17.2324H84.8881V20.4056H87.9859V17.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.117 4.69434H85.757V6.08743H87.117V4.69434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0285 17.5806H89.6107V20.0572H92.0285V17.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7537 9.16406H81.3937V10.5572H82.7537V9.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1882 17.677H80.9592V19.9601H83.1882V17.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4047 22.166H72.2324V24.3911H74.4047V22.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3876 21.6824H89.252V24.8942H92.3876V21.6824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.972 18.1223H107.612V19.5154H108.972V18.1223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.722 22.4563H103.098V24.1203H104.722V22.4563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3903 40.5085H77.0303V41.9016H78.3903V40.5085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8627 4.69434H94.5027V6.08743H95.8627V4.69434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.972 27.0806H107.612V28.4737H108.972V27.0806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7173 21.6243H80.4495V24.9716H83.7173V21.6243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.708 36.3096H107.876V37.1609H108.708V36.3096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9617 40.7793H99.1306V41.6306H99.9617V40.7793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8527 0.496094H86.0216V1.34743H86.8527V0.496094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.126 4.96533H77.2949V5.81667H78.126V4.96533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.972 31.5503H107.612V32.9434H108.972V31.5503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.533 31.6274H103.305V32.8851H104.533V31.6274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8527 49.7375H86.0216V50.5889H86.8527V49.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.126 45.2485H77.2949V46.0999H78.126V45.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7637 44.7073H89.8748V46.6421H91.7637V44.7073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7537 0.224609H81.3937V1.6177H82.7537V0.224609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8627 36.0195H94.5027V37.4126H95.8627V36.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4994 40.5085H90.1394V41.9016H91.4994V40.5085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5987 45.2485H94.7676V46.0999H95.5987V45.2485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.609 13.6526H103.249V15.0457H104.609V13.6526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.396 35.8457H98.6962V37.5871H100.396V35.8457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4104 30.97H93.9359V33.5046H96.4104V30.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3818 44.7073H85.4929V46.6421H87.3818V44.7073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7537 44.9783H81.3937V46.3714H82.7537V44.9783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2972 40.0632H94.0682V42.3464H96.2972V40.0632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9105 35.2068H84.9637V38.2252H87.9105V35.2068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1693 4.24927H80.9592V6.51304H83.1693V4.24927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0285 35.4778H89.6107V37.9544H92.0285V35.4778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2828 39.9668H80.865V42.4434H83.2828V39.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2828 35.4778H80.865V37.9544H83.2828V35.4778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3682 30.6599H89.2704V33.8331H92.3682V30.6599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.703 35.9229H103.135V37.5288H104.703V35.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7436 36.3096H72.9125V37.1609H73.7436V36.3096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2727 31.2793H72.3838V33.2141H74.2727V31.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1968 26.887H72.459V28.667H74.1968V26.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7436 18.3931H72.9125V19.2444H73.7436V18.3931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9135 13.7498H72.7612V14.93H73.9135V13.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.491 31.2793H98.6019V33.2141H100.491V31.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3818 40.2375H85.4929V42.1724H87.3818V40.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2595 26.1714H76.1428V29.3639H79.2595V26.1714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7306 35.6907H76.6906V37.7803H78.7306V35.6907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9193 30.9888H76.4825V33.4847H78.9193V30.9888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9194 22.0498H76.5016V24.5264H78.9194V22.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3903 9.16406H77.0303V10.5572H78.3903V9.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4657 13.5754H76.9546V15.1233H78.4657V13.5754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9948 17.5034H76.4259V20.1348H78.9948V17.5034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7173 30.5825H80.4495V33.9298H83.7173V30.5825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6993 23.501V20.618H56.9702V23.501H60.7481V35.0327H63.9215V23.501H67.6993ZM49.4901 25.3391C49.4901 24.0814 49.8868 23.3462 51.4546 23.3462C52.4746 23.3462 53.8535 23.4816 55.0813 23.6945L55.5347 20.8696C54.1369 20.56 52.8713 20.4246 51.4546 20.4246C47.9034 20.4246 46.3167 22.224 46.3167 24.836V30.8534C46.3167 33.4655 47.9034 35.2649 51.4546 35.2649C52.8713 35.2649 54.1369 35.1101 55.5347 34.8199L55.1002 31.9756C53.8724 32.1885 52.4746 32.3239 51.4735 32.3239C49.9057 32.3239 49.509 31.5886 49.509 30.331V25.3391H49.4901ZM43.7667 20.6374H40.5933V35.052H43.7667V20.6374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8543 29.7505C37.8543 28.2219 37.7032 27.7576 35.5687 27.2739C34.6809 27.061 34.6242 27.003 34.6242 26.5386C34.6242 26.1903 34.7753 26.0162 35.4176 26.0162C36.0031 26.0162 36.8154 26.113 37.4765 26.229L37.6843 24.4683C37.0232 24.2942 35.9843 24.2168 35.4176 24.2168C33.1887 24.2168 32.5653 24.894 32.5653 26.4999C32.5653 27.9317 32.7353 28.4348 34.5298 28.8798C35.7198 29.17 35.7387 29.2474 35.7387 29.7311C35.7387 30.1761 35.6254 30.3696 34.9831 30.3696C34.152 30.3696 33.3398 30.2148 32.7353 30.0213L32.3764 31.7047C33.1131 31.9562 34.2653 32.1497 35.0776 32.1497C37.2121 32.1884 37.8543 31.3177 37.8543 29.7505ZM31.2619 29.7505C31.2619 28.2219 31.1108 27.7576 28.9763 27.2739C28.0886 27.061 28.0319 27.003 28.0319 26.5386C28.0319 26.1903 28.183 26.0162 28.8252 26.0162C29.4108 26.0162 30.223 26.113 30.8842 26.229L31.0731 24.4683C30.4119 24.2942 29.373 24.2168 28.8063 24.2168C26.5774 24.2168 25.9541 24.894 25.9541 26.4999C25.9541 27.9317 26.1241 28.4348 27.9374 28.8798C29.1275 29.17 29.1464 29.2474 29.1464 29.7311C29.1464 30.1761 29.033 30.3696 28.3908 30.3696C27.5597 30.3696 26.7474 30.2148 26.143 30.0213L25.7841 31.7047C26.5207 31.9562 27.673 32.1497 28.4852 32.1497C30.6197 32.1884 31.2619 31.3177 31.2619 29.7505ZM24.3107 24.3909H22.1007V32.0336H24.3107V24.3909ZM17.1328 32.0336H19.5128L20.7973 24.3909H18.7762L18.0773 28.8604L16.7928 24.3909H14.5827L13.2794 28.8604L12.5805 24.3909H10.5593L11.8438 32.0336H14.2238L15.6594 27.0417L17.1328 32.0336ZM9.57709 29.7505C9.57709 28.2219 9.42598 27.7576 7.29149 27.2739C6.4037 27.061 6.34703 27.003 6.34703 26.5386C6.34703 26.1903 6.49815 26.0162 7.14038 26.0162C7.72595 26.0162 8.53818 26.113 9.19931 26.229L9.40709 24.4683C8.74597 24.2942 7.70706 24.2168 7.14038 24.2168C4.91145 24.2168 4.2881 24.894 4.2881 26.4999C4.2881 27.9317 4.45811 28.4348 6.25258 28.8798C7.44261 29.17 7.4615 29.2474 7.4615 29.7311C7.4615 30.1761 7.34816 30.3696 6.68704 30.3696C5.85591 30.3696 5.04367 30.2148 4.43922 30.0213L4.08032 31.7047C4.817 31.9562 5.96925 32.1497 6.78148 32.1497C8.93486 32.1884 9.57709 31.3177 9.57709 29.7505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3297 21.7402H22.1196V23.4429H24.3297V21.7402Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_3278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.0bcfaf420f54db8710d8680487be5e98.svg";
export { ForwardRef as ReactComponent };